/**
 * Supabase Realtime reuses an existing channel when its topic matches.
 * React StrictMode may remount an effect before asynchronous channel removal
 * completes, so postgres_changes subscriptions need a unique topic per mount.
 *
 * Presence and broadcast channels deliberately do not use this helper because
 * their shared topic is part of their communication contract.
 */
const processNonce = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
let channelSequence = 0;

export function nextPostgresChangesChannelTopic(baseTopic: string): string {
  channelSequence += 1;
  return `${baseTopic}:instance:${processNonce}:${channelSequence}`;
}
